export default "__VITE_PUBLIC_ASSET__47c62669__"